import { netSuiteEmailQuotesRegex, netSuiteEmailRegex } from './validations.constants';

export const isNetSuiteUrlValid = (urlString: string) => {
    try {
        const newUrl = new URL(urlString);

        return newUrl.protocol === 'http:' || newUrl.protocol === 'https:';
    } catch {
        return false;
    }
};

export const isNetSuiteEmailValid = (emailString: string) => {
    if (!emailString) {
        return true;
    }

    return !netSuiteEmailQuotesRegex.test(emailString) && netSuiteEmailRegex.test(emailString);
};
